import { Card } from "antd";
import { ReactComponent as DeleteIcon } from "../../assets/icons/delete.svg";
import { ReactComponent as CheckIcon } from "../../assets/icons/greenCheck.svg";
import Screen from "../../assets/icons/PDF.svg";
import { DeleteOutlined } from "@ant-design/icons";

const SupportTicket = ({ data, openModal }) => {
  const handleScreenShot = (e) => {
    e.stopPropagation();
  };
  const handlePdfClick = () => {
    const pdfUrl = data?.image;
    if (pdfUrl) window.open(pdfUrl, "_blank");
  };
  return (
    <Card className="mb-2 shadow-md">
      <div className=" flex justify-center grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 justify-between mx-3">
        <div className="mr-0">
          <p className="text-primaryPurple font-bold text-lg">Ticket #</p>
          <p>{data?._id?.slice(-6) || data?.ticketNumber}</p>
        </div>
        <div className="ml-0">
          <p className="text-primaryPurple font-bold text-lg">Category</p>
          <p>{data?.supportCategory?.name || data?.supportCategoryId?.name}</p>
        </div>
        <div>
          {/* <div className="flex justify-center"> */}
          <p className="flex sm:justify-center md:justify-start text-primaryPurple font-bold text-lg ">
            Title
          </p>
          {/* </div> */}
          <div>
            <p className="flex sm:justify-center md:justify-start">
              {data?.issueTitle}
            </p>
          </div>
        </div>
        {data?.image ? (
          <div className="ml-0 " onClick={handleScreenShot}>
            <div className="flex justify-start">
              <p className="text-primaryPurple font-bold text-lg ">
                Attachment
              </p>
            </div>
            <div className="flex sm:justify-start">
              <img
                src={Screen}
                onClick={handlePdfClick}
                alt="Team Icon"
                className="mr-1 mb-2 hover:cursor-pointer"
              />
            </div>
          </div>
        ) : (
          <div className="ml-0" onClick={handleScreenShot}>
            <div className="">
              <p className="text-primaryPurple font-bold text-lg ">
                Attachment
              </p>
            </div>
            <div className="">
              <p>No Attachments</p>
            </div>
          </div>
        )}
        <div className="flex items-center justify-end">
          <DeleteIcon
            className="hover:cursor-pointer"
            onClick={() => openModal(data?._id)}
          />
        </div>
        <div className="flex items-center">
          <p className="m-2 text-lg font-light">{data?.status} </p>
          {data?.status === "RESOLVED" ? (
            <CheckIcon className="hover:cursor-pointer" />
          ) : (
            ""
          )}
        </div>
      </div>
    </Card>
  );
};
export default SupportTicket;
